const { planQuery } = (() => {
/** Pure lexical assistance. Shopify remains the semantic search engine; the natural query is never replaced. */
const DEFINITIONS = [
  ['gift','occasion','gift','gift|gifts|regalo|regalos|regali|cadeau|cadeaux|geschenk|geschenke|presente|presentes|هدية|هدايا|礼物|礼品|禮物|禮品'],
  ['christmas','occasion','Christmas','christmas|xmas|navidad|natale|noël|noel|weihnachten|عيد الميلاد|كريسماس|圣诞|圣诞节|聖誕|聖誕節'],
  ['halloween','occasion','Halloween','halloween|noche de brujas|万圣节|萬聖節|هالوين'],
  ['birthday','occasion','birthday','birthday|cumpleaños|compleanno|anniversaire|geburtstag|عيد ميلاد|生日'],
  ['wedding','occasion','wedding','wedding|boda|nozze|matrimonio|mariage|hochzeit|زفاف|婚礼|婚禮'],
  ['women','recipient','women','women|woman|ladies|lady|mujer|mujeres|donna|donne|femme|femmes|frau|frauen|dame|damen|امرأة|امراة|نساء|للمرأة|للمراة|女士|女人|女性|女装|女裝'],
  ['men','recipient','men','men|man|mens|hombre|hombres|uomo|uomini|homme|hommes|mann|männer|herren|رجل|رجال|男士|男人|男装|男裝'],
  ['kids','recipient','kids','kids|children|child|niño|niña|niños|niñas|bambino|bambina|bambini|enfant|enfants|kind|kinder|طفل|أطفال|儿童|兒童|孩子'],
  ['couple','recipient','couple','couple|couples|pareja|parejas|coppia|coppie|paar|paare|زوجين|情侣|情侶'],
  ['china','country','China','china|chinese|chino|chinos|chinas|cina|chine|cinese|cinesi|chinois|chinoise|chinoises|chinesisch|chinesische|الصين|صيني|صينية|中国|中國'],
  ['usa','country','USA','usa|united states|united states of america|estados unidos|stati uniti|états unis|etats unis|vereinigte staaten|الولايات المتحدة|امريكا|美国|美國'],
  ['uk','country','UK','uk|united kingdom|britain|british|reino unido|gran bretaña|regno unito|royaume uni|großbritannien|grossbritannien|بريطانيا|英国|英國'],
  ['france','country','France','france|french|francia|francés|francesa|francese|français|française|frankreich|فرنسا|法国|法國'],
  ['italy','country','Italy','italy|italian|italia|italiano|italiana|italie|italien|italienne|italienisch|ايطاليا|意大利|義大利'],
  ['spain','country','Spain','spain|spanish|españa|espana|español|spagna|espagne|spanien|اسبانيا|西班牙'],
  ['germany','country','Germany','germany|german|alemania|alemán|allemagne|germania|deutschland|deutsch|المانيا|德国|德國'],
  ['canada','country','Canada','canada|canadá|canadian|canadiense|canadese|canadien|kanada|كندا|加拿大'],
  ['egypt','country','Egypt','egypt|egyptian|egipto|egipcio|egitto|egypte|égyptien|ägypten|مصر|مصري|埃及'],
  ['japan','country','Japan','japan|japanese|japón|japon|giappone|japonais|japonaise|japanisch|اليابان|日本'],
  ['africa','region','Africa','africa|áfrica|african|africano|africana|afrique|afrika|افريقيا|非洲'],
  ['red','color','red','red|rojo|roja|rojos|rojas|rosso|rossa|rossi|rosse|rouge|rouges|rot|rote|roter|rotes|roten|احمر|حمراء|红色|红|紅色|紅'],
  ['pink','color','pink','pink|rosa|rosado|rosada|rose|rosarot|وردي|粉色|粉红|粉紅'],
  ['blue','color','blue','blue|azul|azules|azzurro|azzurra|azzurri|azzurre|blu|bleu|bleue|bleus|bleues|blau|blaue|blauer|blaues|blauen|ازرق|زرقاء|蓝色|蓝|藍色|藍'],
  ['green','color','green','green|verde|verdes|verdi|vert|verte|verts|vertes|grün|grüne|grüner|grünes|grünen|grun|اخضر|خضراء|绿色|绿|綠色|綠'],
  ['black','color','black','black|negro|negra|negros|negras|nero|nera|neri|nere|noir|noire|noirs|noires|schwarz|schwarze|schwarzer|schwarzes|schwarzen|اسود|سوداء|黑色|黑'],
  ['white','color','white','white|blanco|blanca|blancos|blancas|bianco|bianca|bianchi|bianche|blanc|blanche|blancs|blanches|weiß|weiss|weiße|weißer|weißes|weißen|ابيض|بيضاء|白色|白'],
  ['gold','color','gold','gold|golden|dorado|dorada|oro|doré|dorée|dore|doree|goldfarben|ذهبي|金色'],
  ['silver-tone','color','silver','silver|plateado|plateada|argento|argenté|argentée|silber|فضي|银色|銀色'],
  ['brown','color','brown','brown|marrón|marron|marrone|brun|brune|braun|بني|棕色'],
  ['grey','color','grey','grey|gray|gris|grigio|grigia|grau|رمادي|灰色'],
  ['purple','color','purple','purple|morado|morada|viola|violet|violette|lila|بنفسجي|紫色'],
  ['bone-china','material','bone china','bone china|porcelana de hueso|porcelaine osseuse|骨瓷|骨质瓷|骨質瓷'],
  ['porcelain','material','porcelain','porcelain|porcelana china|porcelana|porcellana cinese|porcellana|porcelaine chinoise|porcelaine|chinesisches porzellan|porzellan|خزف|بورسلان|瓷器|瓷'],
  ['ceramic','material','ceramic','ceramic|ceramics|cerámica|ceramica|céramique|keramik|سيراميك|陶瓷'],
  ['wood','material','wood','wood|wooden|madera|legno|bois|holz|خشب|木质|木製|木制'],
  ['stainless-steel','material','stainless steel','stainless steel|acero inoxidable|acciaio inossidabile|acier inoxydable|edelstahl|فولاذ مقاوم للصدأ|不锈钢|不鏽鋼'],
  ['sterling-silver','material','sterling silver','sterling silver|plata 925|argento 925|argent 925|sterlingsilber|فضة 925|925银|925銀'],
  ['jewelry','productType','jewelry','jewelry|jewellery|joya|joyas|gioiello|gioielli|bijou|bijoux|schmuck|مجوهرات|珠宝|首饰|珠寶|首飾'],
  ['necklace','productType','necklace','necklace|necklaces|collar|collares|collana|collane|collier|colliers|halskette|halsketten|قلادة|قلادات|عقد|项链|項鏈'],
  ['bracelet','productType','bracelet','bracelet|bracelets|pulsera|pulseras|bracciale|bracciali|armband|armbänder|سوار|أساور|手链|手鏈|手镯|手鐲'],
  ['earrings','productType','earrings','earring|earrings|pendientes|aretes|orecchini|boucles d oreilles|ohrringe|اقراط|أقراط|耳环|耳環'],
  ['ring','productType','ring','ring|rings|anillo|anillos|anello|anelli|bague|bagues|ringe|خاتم|خواتم|戒指'],
  ['cup','productType','cup','cup|cups|mug|mugs|taza|tazas|tazza|tazze|tasse|tasses|becher|tassen|كوب|اكواب|أكواب|杯|杯子|马克杯|馬克杯'],
  ['teapot','productType','teapot','teapot|tetera|teiera|théière|theiere|teekanne|ابريق شاي|茶壶|茶壺'],
  ['bowl','productType','bowl','bowl|bowls|cuenco|cuencos|ciotola|ciotole|bol|bols|schüssel|schussel|وعاء|碗'],
  ['plate','productType','plate','plate|plates|plato|platos|piatto|piatti|assiette|assiettes|teller|طبق|اطباق|盘子|盤子'],
  ['tableware','productType','tableware','tableware|dinnerware|vajilla|stoviglie|vaisselle|geschirr|اواني|餐具'],
  ['dress','productType','dress','dress|dresses|vestido|vestidos|abito|abiti|robe|robes|kleid|kleider|فستان|فساتين|连衣裙|連衣裙|旗袍|cheongsam'],
  ['shirt','productType','shirt','shirt|shirts|t shirt|tshirt|camisa|camiseta|maglietta|chemise|hemd|قميص|تي شيرت|衬衫|襯衫|t恤'],
  ['hoodie','productType','hoodie','hoodie|hoodies|sudadera|felpa|sweat à capuche|kapuzenpullover|连帽衫|連帽衫'],
  ['scarf','productType','scarf','scarf|scarves|bufanda|sciarpa|écharpe|echarpe|schal|وشاح|围巾|圍巾'],
  ['bag','productType','bag','bag|bags|bolso|bolsa|borsa|borsetta|sac|sacs|tasche|taschen|حقيبة|حقائب|包|手提包'],
  ['backpack','productType','backpack','backpack|backpacks|mochila|zaino|sac à dos|rucksack|حقيبة ظهر|背包'],
  ['wallet','productType','wallet','wallet|wallets|cartera|billetera|portafoglio|portefeuille|geldbörse|geldborse|محفظة|钱包|錢包'],
  ['hat','productType','hat','hat|hats|cap|caps|gorra|sombrero|cappello|casquette|hut|mütze|mutze|قبعة|帽子'],
  ['blanket','productType','blanket','blanket|throw|manta|coberta|coperta|plaid|couverture|decke|بطانية|毯子|毛毯'],
  ['pillow','productType','pillow','pillow|cushion|cojín|cojin|cuscino|coussin|kissen|وسادة|枕头|枕頭|靠垫|靠墊'],
  ['figurine','productType','figurine','figurine|statue|sculpture|figura|estatua|statuetta|statuette|skulptur|تمثال|تماثيل|雕像|摆件|擺件'],
  ['souvenir','productType','souvenir','souvenir|souvenirs|recuerdo|recuerdos|ricordo|ricordi|andenken|تذكار|تذكارات|纪念品|紀念品'],
  ['keychain','productType','keychain','keychain|keychains|llavero|portachiavi|porte clés|porte cles|schlüsselanhänger|schlusselanhanger|ميدالية مفاتيح|钥匙扣|鑰匙扣'],
  ['magnet','productType','magnet','magnet|magnets|imán|iman|imanes|calamita|aimant|kühlschrankmagnet|kuhlschrankmagnet|مغناطيس|冰箱贴|冰箱貼'],
  ['notebook','productType','notebook','notebook|diary|journal|cuaderno|agenda|quaderno|carnet|notizbuch|دفتر|笔记本|筆記本'],
  ['music-box','productType','music box','music box|caja de música|caja de musica|carillon|boîte à musique|boite a musique|spieluhr|صندوق موسيقى|音乐盒|音樂盒'],
  ['packing-cubes','productType','packing cubes','packing cubes|organizadores de maleta|cubi da viaggio|organisateurs de valise|packwürfel|packwurfel|مكعبات تعبئة|旅行收纳袋|旅行收納袋'],
  ['lights','productType','lights','light|lights|luces|luz|luci|lumières|lumieres|lichter|اضواء|أضواء|灯|燈|灯串|燈串'],
  ['wreath','productType','wreath','wreath|wreaths|corona navideña|ghirlanda|couronne de noël|weihnachtskranz|اكليل|花环|花環'],
  ['travel','occasion','travel','travel|trip|viaje|viajes|viaggio|viaggi|voyage|voyages|reise|reisen|سفر|رحلة|旅行|旅游|旅遊'],
  ['apple','motif','apple','apple|apples|manzana|manzanas|mela|mele|pomme|pommes|apfel|äpfel|تفاحة|تفاح|苹果|蘋果'],
  ['heart','motif','heart','heart|hearts|corazón|corazon|corazones|cuore|cuori|cœur|coeur|herz|قلب|قلوب|心形'],
  ['map','motif','map','map|maps|mapa|mapas|mappa|mappe|carte géographique|landkarte|خريطة|地图|地圖'],
  ['dragon','motif','dragon','dragon|dragón|drago|drachen|تنين|龙|龍'],
  ['coffee','motif','coffee','coffee|café|cafe|caffè|caffe|kaffee|قهوة|咖啡'],
];

const fold = (text) => String(text).normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/ß/gu, 'ss');
const words = (text) => fold(text).replace(/[’'\-]/gu, ' ').match(/[\p{Script=Han}]+|[\p{L}\p{N}]+/gu) || [];
const STOPWORDS = new Set(words('a an the for of from to with and or please find show me looking want need something some i my s un una unos unas el la los las de del para por con y que quiero busco buscar muestra mostrar algo da di del della delle dei degli il lo i le gli uno una un per con e cerco cerca vorrei une un des du de la le les pour avec et je cherche trouver montre moi der die das ein eine einen einem eines den dem des für fur mit von aus zu zum zur und ich suche suchen bitte un une pour des de du la le et avec à a au aux من الى إلى في مع و اريد أريد ابحث عن لل 给 的 一个 一 个 为 為 我 想 要 找 买 買 寻找 尋找 适合 適合 用于 用於'));
const ALIASES = new Map();
const CONCEPTS = new Map();
for (const [id,kind,value,rawAliases] of DEFINITIONS) {
  const concept={id:`${kind}:${id}`,kind,value,queryTerms:[value]};
  if(id==='cup') concept.queryTerms.push('mug');
  if(id==='figurine') concept.queryTerms.push('statue');
  if(id==='china') concept.queryTerms.push('Chinese');
  CONCEPTS.set(concept.id,concept);
  for(const alias of rawAliases.split('|')) ALIASES.set(words(alias).join(' '),concept);
}
const CJK_UNITS=[...new Set([...ALIASES.keys(),...STOPWORDS].filter(x=>/^[\p{Script=Han}]+$/u.test(x)))].sort((a,b)=>b.length-a.length);
const TYPOS=new Map(Object.entries({neckalce:'necklace',necklce:'necklace',neclace:'necklace',braclet:'bracelet',earings:'earrings',porcelin:'porcelain',porcelian:'porcelain',christams:'christmas',chrismas:'christmas',reglaos:'regalos',navdiad:'navidad',collra:'collar',cofee:'coffee'}));
const MAX_QUERY_LENGTH=200;
function tokenize(text) {
  return words(text).flatMap(token=>{
    if(!/^[\p{Script=Han}]+$/u.test(token))return [token];
    const output=[];let unknown='';
    for(let offset=0;offset<token.length;){const found=CJK_UNITS.find(word=>token.startsWith(word,offset));if(found){if(unknown){output.push(unknown);unknown='';}output.push(found);offset+=found.length;}else{unknown+=token[offset++];}}
    if(unknown)output.push(unknown);return output;
  });
}
const unique=(items)=>[...new Set(items)];
function naturalSuggestion(entities, unknownTerms) {
  const values=(kind)=>entities.filter(entity=>entity.kind===kind).map(entity=>entity.value);
  const occasions=values('occasion').filter(value=>value!=='gift');
  const types=values('productType');
  const descriptors=[...values('country'),...values('region'),...occasions,...values('color'),...values('material'),...values('motif')];
  const recipients=values('recipient');
  const hasGift=entities.some(entity=>entity.id==='occasion:gift');
  const head=[...descriptors,...types, ...(hasGift?['gifts']:[])];
  if(recipients.length) head.push(...(head.length?['for']:[]),...recipients);
  return unique([...head,...unknownTerms]).join(' ');
}
const hasNegation=(query)=>/(?:^|\s)(?:not|without|sin|sans|senza|ohne|بدون)(?:\s|$)|不要|不含/iu.test(query);
const hasSearchSyntax=(query)=>/(?:^|\s)[\w.]+:|["“”]|\b(?:AND|OR|NOT)\b/u.test(query);

/** @returns A serializable assistance plan. primaryQuery always equals original, including unknown words. */
function planQuery(raw, locale='en') {
  const original=String(raw??'').trim().replace(/\s+/gu,' ');
  const plan={version:1,raw:String(raw??''),original,locale:String(locale||'en'),primaryQuery:original,suggestedQuery:null,nativeTerms:[],normalizedTerms:[],entities:[],concepts:[],unknownTerms:[],corrections:[],alternatives:[],ambiguity:[],changed:false,hasInterpretation:false,requiresChoice:false};
  if(!original||original.length>MAX_QUERY_LENGTH||hasSearchSyntax(original)||hasNegation(original))return {...plan,skipInterpretationReason:!original?'empty':original.length>MAX_QUERY_LENGTH?'length-limit':hasSearchSyntax(original)?'explicit-native-syntax':'negation-kept-native'};
  const tokens=tokenize(original);const parts=[];const matches=[];
  for(let at=0;at<tokens.length;){
    let concept=null,length=0,matched='';
    for(let size=Math.min(5,tokens.length-at);size>0;size--){const candidate=tokens.slice(at,at+size).join(' ');const key=ALIASES.has(candidate)?candidate:/^ال[\p{Script=Arabic}]+$/u.test(candidate)?candidate.slice(2):candidate;if(ALIASES.has(key)){concept=ALIASES.get(key);length=size;matched=candidate;break;}}
    let source=length>1?'phrase':'exact';
    if(!concept&&TYPOS.has(tokens[at])){matched=tokens[at];const corrected=TYPOS.get(matched);concept=ALIASES.get(corrected);if(concept){length=1;source='typo';plan.corrections.push({from:matched,to:corrected,reason:'known-spelling'});}}
    if(concept){const entity={...concept,queryTerms:[...concept.queryTerms],matched,source};matches.push(entity);parts.push({value:concept.value,entity});at+=length;continue;}
    const token=tokens[at++];if(STOPWORDS.has(token))continue;
    plan.unknownTerms.push(token);parts.push({value:token});
  }
  plan.nativeTerms=unique(tokens.filter(token=>!STOPWORDS.has(token)));
  plan.entities=matches.filter((entity,index)=>matches.findIndex(other=>other.id===entity.id)===index);
  plan.concepts=plan.entities;
  plan.unknownTerms=unique(plan.unknownTerms);
  plan.normalizedTerms=unique(parts.map(part=>part.value));
  const interpreted=naturalSuggestion(plan.entities,plan.unknownTerms);
  const exactChina=matches.some(entity=>entity.id==='country:china'&&entity.matched==='china');
  const hasExplicitMaterial=matches.some(entity=>entity.kind==='material'&&['bone china','porcelain','ceramic'].includes(entity.value));
  if(exactChina&&!hasExplicitMaterial){
    const remainder=naturalSuggestion(plan.entities.filter(entity=>entity.id!=='country:china'),plan.unknownTerms);
    const styleQuery=`Chinese style ${remainder}`.trim();
    const materialQuery=`${remainder} bone china porcelain`.trim();
    const options=[{id:'china-country',query:styleQuery,labelKey:'chinaEditorial'},{id:'china-material',query:materialQuery,labelKey:'chinaPorcelain'}];
    plan.ambiguity.push({id:'china-meaning',kind:'country-or-material',options});plan.requiresChoice=true;
    plan.alternatives.push(...options.map(option=>({...option,reason:option.id==='china-country'?'china-editorial-theme':'china-material',explicit:true})));
  }
  const translated=matches.some(entity=>!entity.queryTerms.some(term=>words(term).join(' ')===entity.matched));
  if(interpreted&&(translated||plan.corrections.length)&&fold(interpreted)!==fold(original)){
    plan.suggestedQuery=interpreted;plan.hasInterpretation=true;
    plan.alternatives.push({id:'interpreted',query:interpreted,reason:plan.corrections.length?'spelling-and-concepts':'translated-concepts',labelKey:'interpretedQuery',explicit:true});
  }
  plan.alternatives=plan.alternatives.filter((item,index,all)=>item.query!==original&&all.findIndex(other=>fold(other.query)===fold(item.query))===index).slice(0,3);
  return plan;
}

const queryUnderstandingMetadata=Object.freeze({version:1,concepts:DEFINITIONS.length,aliases:ALIASES.size,maxQueryLength:MAX_QUERY_LENGTH,primaryQueryPolicy:'preserve-natural-original',catalogOriginInference:false});

return { planQuery };
})();
const { fetchSearchResults, safeSearchResourceUrl, safeSearchImageUrl } = (() => {
const MAX_MARKUP = 250000;
const text = (value, limit = 500) => typeof value === 'string' ? value.trim().slice(0, limit) : '';
const folded = (value) => text(value).normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();

function safeSearchResourceUrl(value, origin, kind) {
  try {
    if (typeof value !== 'string' || value.length > 2000) return null;
    const url = new URL(value, origin);
    if (url.origin !== origin || url.username || url.password || url.hash) return null;
    const root = '/(?:[a-z]{2}(?:-[a-z]{2,4})?/)?';
    const path = kind === 'query' ? 'search/?' : (kind === 'collection' ? 'collections' : 'products') + '/[^/]+/?';
    if (!new RegExp('^' + root + path + '$', 'i').test(url.pathname)) return null;
    if (kind === 'query') {
      if (!text(url.searchParams.get('q'), 200)) return null;
      url.searchParams.set('type', 'product');
    }
    return url.href;
  } catch { return null; }
}

function safeSearchImageUrl(value, origin) {
  try {
    if (!value || typeof value !== 'string' || value.length > 2000) return null;
    const url = new URL(value, origin);
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    if (url.origin !== origin && !['cdn.shopify.com', 'cdn.shopifycdn.net'].includes(url.hostname)) return null;
    return url.href;
  } catch { return null; }
}

function sanitizeSearchPayload(payload, origin) {
  if (!payload || payload.version !== 1 || !['predictive', 'search'].includes(payload.mode) || !Array.isArray(payload.products) || !Array.isArray(payload.collections) || !Array.isArray(payload.queries)) {
    throw new Error('Unexpected search payload');
  }
  const products = [], collections = [], queries = [], seenProducts = new Set(), seenCollections = new Set(), seenQueries = new Set();
  for (const [nativeIndex, item] of payload.products.slice(0, 10).entries()) {
    const url = safeSearchResourceUrl(item?.url, origin, 'product');
    const title = text(item?.title), price = text(item?.price, 100);
    if (!url || !title || typeof item.available !== 'boolean') continue;
    const parsed = new URL(url), key = parsed.pathname + ':' + (parsed.searchParams.get('variant') || '');
    if (seenProducts.has(key)) continue;
    seenProducts.add(key);
    products.push({ id: text(item.id, 30), handle: text(item.handle, 200), title, type: text(item.type, 100), url, image: safeSearchImageUrl(item.image, origin), price, available: item.available, priceVaries: item.priceVaries === true, nativeIndex });
  }
  for (const item of payload.collections.slice(0, 10)) {
    const url = safeSearchResourceUrl(item?.url, origin, 'collection'), title = text(item?.title, 200);
    if (!url || !title || seenCollections.has(new URL(url).pathname)) continue;
    seenCollections.add(new URL(url).pathname);
    collections.push({ handle: text(item.handle, 200), title, url });
  }
  for (const item of payload.queries.slice(0, 10)) {
    const url = safeSearchResourceUrl(item?.url, origin, 'query'), query = text(item?.text, 200);
    if (!url || !query || seenQueries.has(folded(query))) continue;
    if (new URL(url).searchParams.get('q') !== query) continue;
    seenQueries.add(folded(query));
    queries.push({ text: query, url });
  }
  return { products, collections, queries, mode: payload.mode, terms: text(payload.terms, 200), locale: text(payload.locale, 20), country: text(payload.country, 10), currency: text(payload.currency, 10) };
}

function parseSearchPayload(markup, origin, parser = new DOMParser()) {
  if (typeof markup !== 'string' || markup.length > MAX_MARKUP) throw new Error('Unexpected search response size');
  const document = parser.parseFromString(markup, 'text/html');
  const nodes = document.querySelectorAll('[data-ricordo-search-payload]');
  if (nodes.length !== 1) throw new Error('Missing search payload');
  return sanitizeSearchPayload(JSON.parse(nodes[0].textContent), origin);
}

function rankSearchProducts(products, plan) {
  const original = folded(plan.original || plan.primaryQuery);
  const concepts = (plan.concepts || []).filter((c) => c.source !== 'typo' && ['productType', 'recipient', 'occasion', 'color', 'material', 'motif'].includes(c.kind));
  const score = (product) => {
    const title = folded(product.title);
    if (title === original) return 1000;
    if (original && title.startsWith(original + ' ')) return 900;
    let matches = 0;
    for (const concept of concepts) {
      const terms = Array.isArray(concept.queryTerms) ? concept.queryTerms : [concept.value];
      if (terms.some((term) => {
        const normalized = folded(term);
        return normalized && (' ' + title + ' ').includes(' ' + normalized + ' ');
      })) matches += 1;
    }
    return Math.min(matches, 5) * 10;
  };
  return products.map((product, i) => ({ product, i, score: score(product) }))
    .sort((a, b) => Number(b.product.available) - Number(a.product.available) || b.score - a.score || a.i - b.i)
    .slice(0, 6).map(({ product }) => product);
}

async function requestSearchResults(query, { predictiveUrl, searchUrl, origin, signal, fallback = false, fetcher = globalThis.fetch, parser } = {}) {
  const original = text(query, 200);
  if (!original) throw new Error('Search query required');
  const url = new URL(fallback ? searchUrl : predictiveUrl, origin);
  if (url.origin !== origin || url.username || url.password) throw new Error('Search must stay on this storefront');
  const endpointPath = fallback ? /\/(?:search)\/?$/ : /\/(?:search\/suggest)\/?$/;
  if (!endpointPath.test(url.pathname)) throw new Error('Unexpected search endpoint');
  url.search = '';
  url.searchParams.set('q', original);
  url.searchParams.set('section_id', 'ricordo-search-data');
  if (fallback) {
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'last');
  } else {
    url.searchParams.set('resources[type]', 'product,collection,query');
    url.searchParams.set('resources[limit]', '10');
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
  }
  const response = await fetcher(url, { signal, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } });
  if (!response.ok) {
    const error = new Error('Search response unavailable');
    error.status = response.status;
    const retry = response.headers.get('Retry-After');
    error.retryAfter = Math.max(1, Number(retry) || Math.ceil((Date.parse(retry) - Date.now()) / 1000) || 30);
    throw error;
  }
  const results = parseSearchPayload(await response.text(), origin, parser);
  if (results.terms.normalize('NFKC') !== original.normalize('NFKC')) throw new Error('Search response query mismatch');
  return results;
}

async function fetchSearchResults(plan, options = {}) {
  const original = text(plan.original || plan.primaryQuery, 200);
  let response, usedFallback = options.fallback === true, requests = 1;
  try {
    response = await requestSearchResults(original, options);
  } catch (error) {
    if (error.status !== 417 || usedFallback || options.signal?.aborted) throw error;
    requests += 1;
    usedFallback = true;
    response = await requestSearchResults(original, { ...options, fallback: true });
  }
  const originalProductCount = response.products.length;
  let relatedQuery = null;
  const suggestion = text(plan.suggestedQuery, 200);
  const isNatural = suggestion && !/[":()]/u.test(suggestion) && !/\b(?:AND|OR|NOT)\b/u.test(suggestion);
  if (!originalProductCount && requests < 2 && !options.signal?.aborted && isNatural && folded(suggestion) !== folded(original) && !(plan.ambiguity || []).length) {
    requests += 1;
    try {
      const related = await requestSearchResults(suggestion, { ...options, fallback: usedFallback });
      if (related.products.length) {
        relatedQuery = suggestion;
        response = { ...related, collections: response.collections.length ? response.collections : related.collections, queries: response.queries.length ? response.queries : related.queries };
      }
    } catch (error) {
      if (options.signal?.aborted || error.status === 429) throw error;
    }
  }
  return { ...response, products: rankSearchProducts(response.products, plan), collections: response.collections.slice(0, 2), queries: response.queries.slice(0, 3), relatedQuery, originalProductCount, requests, fallbackApplied: usedFallback };
}

return { fetchSearchResults, safeSearchResourceUrl, safeSearchImageUrl };
})();
const { renderSearchExperience, clearSearchLabel, experienceCopy } = (() => {
// Presentation only. Native Shopify remains responsible for catalog search.
const COPY = {
  en: { products: 'Products', searches: 'Suggested searches', collections: 'Explore collections', product: 'Product', collection: 'Collection', suggestion: 'Search suggestion', alternative: 'Try another search', correction: 'Did you mean', available: 'Available', unavailable: 'Currently unavailable', loading: 'Finding suggestions…', error: 'Suggestions are unavailable right now. You can still search.', empty: 'No product suggestions. Try another phrase or search all results.', summary: '__count__ suggestions available.', all: 'Search all results for', china: 'China collection', porcelain: 'Bone china / porcelain' },
  es: { products: 'Productos', searches: 'Búsquedas sugeridas', collections: 'Explorar colecciones', product: 'Producto', collection: 'Colección', suggestion: 'Búsqueda sugerida', alternative: 'Prueba otra búsqueda', correction: '¿Quisiste decir', available: 'Disponible', unavailable: 'No disponible por ahora', loading: 'Buscando sugerencias…', error: 'No se pudieron cargar las sugerencias. Puedes seguir buscando.', empty: 'No hay sugerencias de productos. Prueba otra frase o consulta todos los resultados.', summary: '__count__ sugerencias disponibles.', all: 'Buscar todos los resultados de', china: 'Colección China', porcelain: 'Porcelana / bone china' },
  it: { products: 'Prodotti', searches: 'Ricerche suggerite', collections: 'Esplora le collezioni', product: 'Prodotto', collection: 'Collezione', suggestion: 'Ricerca suggerita', alternative: 'Prova un’altra ricerca', correction: 'Forse cercavi', available: 'Disponibile', unavailable: 'Al momento non disponibile', loading: 'Ricerca dei suggerimenti…', error: 'I suggerimenti non sono disponibili. Puoi comunque cercare.', empty: 'Nessun suggerimento di prodotto. Prova un’altra frase o cerca tutti i risultati.', summary: '__count__ suggerimenti disponibili.', all: 'Cerca tutti i risultati per', china: 'Collezione Cina', porcelain: 'Porcellana / bone china' },
  fr: { products: 'Produits', searches: 'Recherches suggérées', collections: 'Explorer les collections', product: 'Produit', collection: 'Collection', suggestion: 'Recherche suggérée', alternative: 'Essayer une autre recherche', correction: 'Vouliez-vous dire', available: 'Disponible', unavailable: 'Indisponible pour le moment', loading: 'Recherche de suggestions…', error: 'Les suggestions sont indisponibles. Vous pouvez toujours rechercher.', empty: 'Aucune suggestion de produit. Essayez une autre phrase ou consultez tous les résultats.', summary: '__count__ suggestions disponibles.', all: 'Voir tous les résultats pour', china: 'Collection Chine', porcelain: 'Porcelaine / bone china' },
  de: { products: 'Produkte', searches: 'Suchvorschläge', collections: 'Kollektionen entdecken', product: 'Produkt', collection: 'Kollektion', suggestion: 'Suchvorschlag', alternative: 'Andere Suche ausprobieren', correction: 'Meinten Sie', available: 'Verfügbar', unavailable: 'Derzeit nicht verfügbar', loading: 'Vorschläge werden gesucht…', error: 'Vorschläge sind gerade nicht verfügbar. Sie können trotzdem suchen.', empty: 'Keine Produktvorschläge. Versuchen Sie einen anderen Suchbegriff oder zeigen Sie alle Ergebnisse an.', summary: '__count__ Vorschläge verfügbar.', all: 'Alle Ergebnisse suchen für', china: 'China-Kollektion', porcelain: 'Porzellan / Bone China' },
  'zh-cn': { products: '商品', searches: '搜索建议', collections: '浏览系列', product: '商品', collection: '系列', suggestion: '搜索建议', alternative: '尝试其他搜索', correction: '您是否想搜索', available: '可购买', unavailable: '暂时无法购买', loading: '正在查找建议…', error: '暂时无法加载建议，您仍可继续搜索。', empty: '暂无商品建议。请尝试其他关键词或查看全部结果。', summary: '有 __count__ 条建议。', all: '搜索全部结果', china: '中国系列', porcelain: '骨瓷 / 瓷器' },
  'zh-tw': { products: '商品', searches: '搜尋建議', collections: '瀏覽系列', product: '商品', collection: '系列', suggestion: '搜尋建議', alternative: '嘗試其他搜尋', correction: '您是否想搜尋', available: '可購買', unavailable: '暫時無法購買', loading: '正在尋找建議…', error: '暫時無法載入建議，您仍可繼續搜尋。', empty: '暫無商品建議。請嘗試其他關鍵字或查看全部結果。', summary: '有 __count__ 條建議。', all: '搜尋全部結果', china: '中國系列', porcelain: '骨瓷 / 瓷器' },
};
const RELATED = {
  en: 'Related to “__query__”', es: 'Relacionados con “__query__”',
  it: 'Articoli correlati a “__query__”', fr: 'Articles liés à « __query__ »',
  de: 'Passend zu „__query__“', 'zh-cn': '与“__query__”相关', 'zh-tw': '與「__query__」相關',
};
const CLEAR = { en: 'Clear search', es: 'Limpiar búsqueda', it: 'Cancella ricerca', fr: 'Effacer la recherche', de: 'Suche löschen', 'zh-cn': '清空搜索', 'zh-tw': '清除搜尋' };

function experienceCopy(locale = 'en') {
  const code = String(locale).toLowerCase();
  const selected = /^zh-(?:hant|tw|hk)/.test(code) ? 'zh-tw' : code === 'zh' || /^zh-(?:hans|cn|sg)/.test(code) ? 'zh-cn' : COPY[code.split('-')[0]] ? code.split('-')[0] : 'en';
  return { ...COPY[selected], related: RELATED[selected], clear: CLEAR[selected] };
}

function clearSearchLabel(locale) { return experienceCopy(locale).clear; }

const text = (value) => typeof value === 'string' ? value.trim() : '';
const key = (value) => text(value).normalize('NFKC').toLocaleLowerCase();

function safeLink(value, kind, origin) {
  try {
    const url = new URL(value, origin);
    const suffix = kind === 'search' ? 'search' : `${kind}/[^/]+`;
    if (url.origin !== origin || url.username || url.password || !new RegExp(`^/(?:[a-z]{2}(?:-[a-z]{2,4})?/)?${suffix}/?$`, 'i').test(url.pathname)) return null;
    return url.href;
  } catch {
    return null;
  }
}

function safeImage(value, origin) {
  if (!text(value)) return null;
  try {
    const url = new URL(value, origin);
    return url.protocol === 'https:' && !url.username && !url.password &&
      (url.origin === origin || ['cdn.shopify.com', 'cdn.shopifycdn.net'].includes(url.hostname)) ? url.href : null;
  } catch {
    return null;
  }
}

function alternativeLabel(alternative, copy) {
  const labelKey = String(alternative.labelKey || alternative.id || '').toLowerCase();
  // A planner alternative is a search, never a claim of product origin or a
  // collection destination. Keep the full proposed phrase visible.
  if (/chinaeditorial|china.*country|country.*china/.test(labelKey)) return text(alternative.query);
  if (/chinaporcelain|porcelain|bone.china|china.material/.test(labelKey)) return `${copy.porcelain} · ${text(alternative.query)}`;
  return text(alternative.label) || text(alternative.query);
}

/** Return display-safe groups without changing the submitted natural query. */
function searchPresentation({ plan, results = {}, locale, searchUrl, origin, state = 'ready' }) {
  const copy = experienceCopy(locale || results.locale || plan.locale);
  const original = text(plan.original ?? plan.raw ?? plan.primaryQuery);
  const allUrl = safeLink(searchUrl(original), 'search', origin);
  const ready = state === 'ready' || state === 'empty';
  const relatedQuery = ready && text(results.relatedQuery) && key(results.relatedQuery) !== key(original) ? text(results.relatedQuery) : '';
  const productKeys = new Set();
  const products = ready ? (results.products || []).flatMap((product) => {
    const title = text(product.title), price = text(product.price);
    const url = safeLink(product.url, 'products', origin);
    if (!title || !price || !url) return [];
    const id = new URL(url).pathname;
    if (productKeys.has(id)) return [];
    productKeys.add(id);
    return [{ title, price, url, image: safeImage(product.image, origin), available: typeof product.available === 'boolean' ? product.available : null }];
  }).slice(0, 6) : [];
  const collectionKeys = new Set();
  const collections = ready ? (results.collections || []).flatMap((collection) => {
    const title = text(collection.title), url = safeLink(collection.url, 'collections', origin);
    if (!title || !url || collectionKeys.has(new URL(url).pathname)) return [];
    collectionKeys.add(new URL(url).pathname);
    return [{ title, url, image: safeImage(collection.image, origin) }];
  }).slice(0, 2) : [];

  const ambiguityIds = new Set((plan.ambiguity || []).flatMap((choice) => (choice.options || []).map((option) => option.id)));
  const alternatives = (plan.alternatives || []).map((alternative) => ({
    text: alternativeLabel(alternative, copy), query: text(alternative.query),
    url: safeLink(searchUrl(text(alternative.query)), 'search', origin),
    reason: String(alternative.reason || alternative.source || ''), source: 'alternative',
    urgent: ambiguityIds.has(alternative.id) || /typo|spell|correct/i.test(String(alternative.reason || alternative.source || '')),
  }));
  if (relatedQuery) alternatives.unshift({ text: relatedQuery, query: relatedQuery, url: safeLink(searchUrl(relatedQuery), 'search', origin), source: 'alternative', reason: 'related-search', urgent: true });
  const urgent = alternatives.filter((alternative) => alternative.urgent);
  const others = alternatives.filter((alternative) => !urgent.includes(alternative));
  const native = ready ? (results.queries || []).map((query) => ({ text: text(query.text), query: text(query.text), url: safeLink(query.url, 'search', origin), source: 'native', reason: '' })) : [];
  const queryKeys = new Set([key(original)]);
  const queries = [...urgent, ...native, ...others].flatMap((query) => {
    if (!query.text || !query.query || !query.url) return [];
    // Native suggested text can differ from its request query; dedupe the URL's
    // actual query as well so one destination never consumes two option slots.
    const queryValue = new URL(query.url).searchParams.get('q');
    if (!queryValue || queryKeys.has(key(queryValue))) return [];
    queryKeys.add(key(queryValue));
    return [query];
  }).slice(0, 3);
  const optionCount = products.length + collections.length + queries.length;
  const message = state === 'loading' ? copy.loading : state === 'error' || state === 'cooldown' ? copy.error : !products.length ? copy.empty : '';
  return { original, allUrl, products, collections, queries, copy, optionCount, message, state, relatedQuery };
}

/**
 * Render into the existing combobox list. The controller keeps focus, keyboard
 * selection, open/close state, async requests and viewport fitting.
 */
function renderSearchExperience({ list, empty, status, dataset = {}, plan, results = {}, announce = false, searchUrl, listId = list.id, state = 'ready' }) {
  const doc = list.ownerDocument || document;
  const origin = doc.location?.origin || globalThis.location?.origin || new URL(searchUrl(plan.original || plan.primaryQuery)).origin;
  const presentation = searchPresentation({ plan, results, locale: results.locale || dataset.locale, searchUrl, origin, state });
  const { copy, products, collections, queries } = presentation;
  list.replaceChildren();
  let optionIndex = 0;
  const make = (tag, className, value) => {
    const node = doc.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  };
  const heading = (label) => {
    const item = make('li', 'rc-header-search__group-label', label);
    item.setAttribute('role', 'presentation');
    list.append(item);
  };
  const option = (url, className, accessibleLabel) => {
    const item = make('li'); item.setAttribute('role', 'presentation');
    const link = make('a', `rc-header-search__result ${className || ''}`.trim());
    link.href = url;
    link.id = `${listId}-option-${optionIndex++}`;
    link.tabIndex = -1;
    link.setAttribute('role', 'option');
    link.setAttribute('aria-selected', 'false');
    link.setAttribute('aria-label', accessibleLabel);
    item.append(link); list.append(item);
    return link;
  };
  if (queries.length) {
    heading(copy.searches);
    for (const query of queries) {
      const correction = /typo|spell|correct/i.test(query.reason);
      const prefix = correction ? copy.correction : query.source === 'native' ? copy.suggestion : copy.alternative;
      const link = option(query.url, 'rc-header-search__result--query', `${prefix}: ${query.text}`);
      const icon = make('span', 'rc-header-search__query-icon', '↗'); icon.setAttribute('aria-hidden', 'true');
      const caption = correction ? `${copy.correction}: ${query.text}${copy.correction.startsWith('¿') ? '?' : ''}` : query.text;
      link.append(icon, make('span', 'rc-header-search__query-copy', caption));
    }
  }
  if (products.length) {
    heading(presentation.relatedQuery ? copy.related.replace('__query__', presentation.relatedQuery) : copy.products);
    for (const product of products) {
      const availability = product.available === true ? copy.available : product.available === false ? copy.unavailable : '';
      const link = option(product.url, '', `${copy.product}: ${product.title}. ${product.price}${availability ? `. ${availability}` : ''}`);
      if (product.image) {
        const image = make('img', 'rc-header-search__image');
        Object.assign(image, { src: product.image, alt: '', width: 56, height: 56, loading: 'lazy', decoding: 'async' });
        link.append(image);
      }
      const content = make('span', 'rc-header-search__result-copy');
      content.append(make('span', 'rc-header-search__product-title', product.title), make('span', 'rc-header-search__price', product.price));
      if (availability) content.append(make('span', 'rc-header-search__availability', availability));
      link.append(content);
    }
  }
  if (collections.length) {
    heading(copy.collections);
    for (const collection of collections) {
      const link = option(collection.url, 'rc-header-search__result--collection', `${copy.collection}: ${collection.title}`);
      const content = make('span', 'rc-header-search__query-copy', collection.title);
      const arrow = make('span', 'rc-header-search__collection-arrow', '→'); arrow.setAttribute('aria-hidden', 'true');
      link.append(content, arrow);
    }
  }
  if (presentation.allUrl) {
    const caption = `${copy.all} “${presentation.original}”`;
    option(presentation.allUrl, 'rc-header-search__result--all', caption).append(make('span', '', caption));
  }
  empty.hidden = !presentation.message;
  empty.textContent = presentation.message;
  let announcement = presentation.state === 'ready' || presentation.state === 'empty' ?
    presentation.optionCount ? copy.summary.replace('__count__', String(presentation.optionCount)) : copy.empty : presentation.message;
  if (presentation.relatedQuery && products.length) announcement += ` ${copy.related.replace('__query__', presentation.relatedQuery)}.`;
  status.textContent = announce ? announcement : '';
  return { optionCount: optionIndex, productCount: products.length, announcement, presentation };
}

return { renderSearchExperience, clearSearchLabel, experienceCopy };
})();
export { planQuery };

function normalizeSearchQuery(value) { const plan = planQuery(value, document.documentElement.lang); return { ...plan, query: plan.original, aliased: false }; }

export function suggestionIndex(key, current, length) {
  if (!length) return -1;
  if (key === 'ArrowDown') return current < length - 1 ? current + 1 : 0;
  if (key === 'ArrowUp') return current > 0 ? current - 1 : length - 1;
  return current;
}

export class LatestSearch {
  constructor(fetcher, onResult, onError, { delay = 260, timeout = 7000, timers = globalThis } = {}) {
    Object.assign(this, { fetcher, onResult, onError, delay, timeout, timers });
    this.version = 0;
  }

  cancel() {
    this.version += 1;
    this.timers.clearTimeout(this.timer);
    this.timers.clearTimeout(this.deadline);
    this.controller?.abort();
    this.controller = null;
  }

  schedule(query) {
    this.cancel();
    const version = this.version;
    this.timer = this.timers.setTimeout(() => this.run(query, version), this.delay);
  }

  async run(query, version) {
    if (version !== this.version) return;
    const controller = new AbortController();
    this.controller = controller;
    const deadline = this.timers.setTimeout(() => {
      if (version !== this.version) return;
      this.cancel();
      this.onError(new Error('Search request timed out'), query);
    }, this.timeout);
    this.deadline = deadline;
    try {
      const result = await this.fetcher(query, controller.signal);
      if (version === this.version && !controller.signal.aborted) this.onResult(result, query);
    } catch (error) {
      if (version === this.version && !controller.signal.aborted) this.onError(error, query);
    } finally {
      this.timers.clearTimeout(deadline);
      if (this.controller === controller) this.controller = null;
    }
  }
}

export class RicordoHeaderAutocomplete extends (globalThis.HTMLElement || class {}) {
  connectedCallback() {
    this.observer?.disconnect();
    this.refreshElements();
    // Header hydration uses native subtree preservation. Also recover if the
    // editor or another section update actually replaces these child nodes.
    this.observer = new MutationObserver(() => this.refreshElements());
    this.observer.observe(this, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['role', 'aria-autocomplete', 'aria-haspopup', 'aria-controls', 'aria-expanded', 'value'],
    });
  }

  refreshElements() {
    if (!this.isConnected) return;
    const refs = {
      form: this.querySelector('form'),
      input: this.querySelector('input[name="q"]'),
      panel: this.querySelector('.rc-header-search__panel'),
      list: this.querySelector('.rc-header-search__results'),
      status: this.querySelector('.rc-header-search__status'),
      empty: this.querySelector('.rc-header-search__empty'),
    };
    if (Object.values(refs).some((node) => !node)) return;
    if (!this.events?.signal.aborted && Object.entries(refs).every(([name, node]) => this[name] === node)) {
      if (this.inputFocused && this.lastValue !== undefined && this.input.value !== this.lastValue) {
        this.input.value = this.lastValue;
        this.restoreSelection();
      }
      this.restoreAria();
      return;
    }
    const previousInput = this.input;
    const active = document.activeElement;
    const restoreFocus = previousInput && this.inputFocused &&
      (active === previousInput || !active || active === document.body);
    const presentation = this.isOpen ? this.presentation : null;
    const wasBusy = this.busy;
    this.events?.abort();
    this.latest?.cancel();
    this.events = new AbortController();
    Object.assign(this, refs);
    this.clearButton = this.querySelector('.rc-header-search__clear');
    if (this.clearButton) { this.clearButton.setAttribute('aria-label', clearSearchLabel(document.documentElement.lang)); this.clearButton.hidden = !(this.lastValue ?? this.input.value); }
    this.activeIndex = -1;
    this.composing = previousInput === this.input && this.composing;
    this.blockedUntil ??= 0;
    if (this.lastValue === undefined) this.rememberInput();
    else this.input.value = this.lastValue;
    if (this.useSearchFallback === undefined) {
      try {
        this.useSearchFallback = JSON.parse(document.getElementById('shopify-features')?.textContent || '{}').predictiveSearch === false;
      } catch {
        this.useSearchFallback = false;
      }
    }
    if (restoreFocus) {
      this.input.focus({ preventScroll: true });
      this.restoreSelection();
    }
    this.inputFocused = document.activeElement === this.input;
    this.restoreAria();
    this.latest = new LatestSearch(
      (query, signal) => this.fetchProducts(query, signal),
      (products, query) => {
        if (!this.ownsQuery(query)) return;
        if (products.fallbackApplied) this.useSearchFallback = true;
        this.render(products, query, true, 'ready');
        this.setBusy(false);
      },
      (error, query) => {
        if (error.status === 429) this.blockedUntil = Date.now() + Math.max(1, error.retryAfter || 30) * 1000;
        if (!this.ownsQuery(query)) return;
        this.render({ products: [], collections: [], queries: [] }, query, true, error.status === 429 ? 'cooldown' : 'error');
        this.setBusy(false);
      }
    );
    const options = { signal: this.events.signal };
    this.input.addEventListener('input', (event) => this.onInput(event), options);
    this.input.addEventListener('focus', () => { this.inputFocused = true; this.onInput(); }, options);
    this.input.addEventListener('select', () => this.rememberInput(), options);
    this.input.addEventListener('keyup', () => this.rememberInput(), options);
    this.input.addEventListener('pointerup', () => this.rememberInput(), options);
    this.input.addEventListener('keydown', (event) => this.onKeyDown(event), options);
    this.list.addEventListener('mousedown', (event) => {
      const option = event.target.closest?.('a[role="option"]');
      if (event.button === 0 && option && this.list.contains(option)) event.preventDefault();
    }, options);
    this.input.addEventListener('compositionstart', () => this.onCompositionStart(), options);
    this.input.addEventListener('compositionend', () => this.onCompositionEnd(), options);
    this.form.addEventListener('submit', () => this.onSubmit(), options);
    this.clearButton?.addEventListener('click', () => {
      this.input.value = '';
      this.rememberInput();
      this.close();
      this.input.focus({ preventScroll: true });
    }, options);
    this.addEventListener('focusout', () => {
      queueMicrotask(() => {
        this.refreshElements();
        if (!this.contains(document.activeElement)) { this.inputFocused = false; this.close(); }
      });
    }, options);
    document.addEventListener('pointerdown', (event) => {
      if (!this.contains(event.target)) { this.inputFocused = false; this.close(); }
    }, options);
    document.addEventListener('focusin', (event) => {
      if (!this.contains(event.target)) { this.inputFocused = false; this.close(); }
    }, options);
    const resizeOptions = { ...options, passive: true };
    window.addEventListener('resize', () => this.fitPanel(), resizeOptions);
    window.addEventListener('scroll', () => this.fitPanel(), resizeOptions);
    window.visualViewport?.addEventListener('resize', () => this.fitPanel(), resizeOptions);
    window.visualViewport?.addEventListener('scroll', () => this.fitPanel(), resizeOptions);
    if (presentation && this.inputFocused && !this.composing) {
      this.render(presentation.results, presentation.query, presentation.announce, presentation.state);
      this.setBusy(wasBusy);
      if (wasBusy && Date.now() >= this.blockedUntil) this.latest.schedule(presentation.query);
    } else {
      this.close();
    }
  }

  rememberInput() {
    this.lastValue = this.input.value;
    if (this.clearButton) this.clearButton.hidden = !this.lastValue;
    this.selection = [this.input.selectionStart, this.input.selectionEnd, this.input.selectionDirection];
  }

  restoreSelection() {
    if (Number.isInteger(this.selection?.[0])) this.input.setSelectionRange(...this.selection);
  }

  restoreAria() {
    const attributes = {
      role: 'combobox', 'aria-autocomplete': 'list', 'aria-haspopup': 'listbox',
      'aria-controls': this.list.id, 'aria-expanded': String(Boolean(this.isOpen)),
    };
    for (const [name, value] of Object.entries(attributes)) {
      if (this.input.getAttribute(name) !== value) this.input.setAttribute(name, value);
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.events?.abort();
    this.latest?.cancel();
  }

  ownsQuery(query) {
    return this.isConnected && this.contains(document.activeElement) && !this.composing && normalizeSearchQuery(this.input.value).query === query.query;
  }

  searchUrl(query) {
    const url = new URL(this.form.action, location.origin);
    if (url.origin !== location.origin) throw new Error('Search must stay on this storefront');
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    return url;
  }

  async fetchProducts(query, signal) {
    return fetchSearchResults(query, {
      predictiveUrl: this.dataset.predictiveUrl,
      searchUrl: this.form.action,
      origin: location.origin,
      signal,
      fallback: this.useSearchFallback,
    });
  }

  onCompositionStart() {
    this.rememberInput();
    this.composing = true;
    this.close();
  }

  onCompositionEnd() {
    this.composing = false;
    this.onInput();
  }

  onInput(event) {
    this.rememberInput();
    this.inputFocused = document.activeElement === this.input;
    this.close();
    if (this.composing || event?.isComposing) return;
    const query = normalizeSearchQuery(this.input.value);
    if (query.original.length < 2 && !query.concepts.length) return;
    const state = Date.now() < this.blockedUntil ? 'cooldown' : query.original.length > 200 ? 'error' : 'loading';
    this.render({ products: [], collections: [], queries: [] }, query, true, state);
    if (state !== 'loading') return;
    this.setBusy(true);
    this.latest.schedule(query);
  }

  onSubmit() {
    if (!this.composing) {
      const query = normalizeSearchQuery(this.input.value);
      if (query.aliased) this.input.value = query.query;
    }
    this.rememberInput();
    this.close();
  }

  onKeyDown(event) {
    if (this.composing || event.isComposing || event.keyCode === 229) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key === 'Tab') {
      this.close();
      return;
    }
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      if (this.panel.hidden) this.onInput();
      const options = this.list.querySelectorAll('[role="option"]');
      if (!options.length || this.panel.hidden) return;
      event.preventDefault();
      this.select(suggestionIndex(event.key, this.activeIndex, options.length));
    } else if (event.key === 'Enter' && !this.panel.hidden && this.activeIndex >= 0) {
      const option = this.list.querySelectorAll('[role="option"]')[this.activeIndex];
      if (!option) return;
      event.preventDefault();
      option.click();
    }
  }

  select(index) {
    this.activeIndex = index;
    const options = this.list.querySelectorAll('[role="option"]');
    options.forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
    const selected = options[index];
    if (selected) {
      this.input.setAttribute('aria-activedescendant', selected.id);
      selected.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    } else {
      this.input.removeAttribute('aria-activedescendant');
    }
  }

  setBusy(busy) {
    this.busy = busy;
    this.list.setAttribute('aria-busy', String(busy));
  }

  close() {
    this.isOpen = false;
    this.presentation = null;
    this.latest?.cancel();
    this.panel.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
    this.activeIndex = -1;
    this.status.textContent = '';
    this.setBusy(false);
  }

  fitPanel() {
    if (!this.panel || this.panel.hidden) return;
    const viewport = window.visualViewport;
    const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    const remaining = bottom - this.panel.getBoundingClientRect().top - 12;
    this.panel.style.maxHeight = Math.max(0, Math.min(420, remaining)) + 'px';
  }

  render(results, query, announce, state = 'ready') {
    this.isOpen = true;
    this.presentation = { results, query, announce, state };
    this.activeIndex = -1;
    this.input.removeAttribute('aria-activedescendant');
    renderSearchExperience({
      list: this.list, empty: this.empty, status: this.status,
      dataset: { ...this.dataset, locale: document.documentElement.lang },
      plan: query, results, announce, state,
      searchUrl: (term) => this.searchUrl(term).href, listId: this.list.id,
    });
    this.panel.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    this.fitPanel();
  }

}

if (globalThis.customElements && !customElements.get('ricordo-header-autocomplete')) {
  customElements.define('ricordo-header-autocomplete', RicordoHeaderAutocomplete);
}

const { createRecentRecommendations } = (() => {
/** Consented, session-only product context. No customer data, search history or cookies. */
const RECENT_VIEW_KEY = 'ricordo:last-view:v1';
const RECENT_VIEW_TTL = 2 * 60 * 60 * 1000;
const ID = /^\d{1,20}$/;
const HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/i;

function parseRecentPayload(html) {
  const document = new DOMParser().parseFromString(html, 'text/html');
  const nodes = document.querySelectorAll('[data-ricordo-recent-payload]');
  if (nodes.length !== 1) throw new Error('Invalid recommendation payload');
  return JSON.parse(nodes[0].textContent);
}

/** Dependencies are injected so permission, races and storage failures can be tested. */
function createRecentRecommendations(options) {
  const {
    shopify, document, getStorage, fetcher, origin, root = '/',
    country, currency, onState = () => {}, onPermissionChange = () => {},
    now = Date.now, parsePayload = parseRecentPayload,
    setTimer = setTimeout, clearTimer = clearTimeout,
    requestTimeout = 8000, privacyTimeout = 3000, bandRatio = 0.2,
  } = options;
  const base = new URL(origin);
  const routeRoot = new URL(root, base);
  if (base.protocol !== 'https:' || routeRoot.origin !== base.origin ||
      !/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?$/i.test(routeRoot.pathname) ||
      routeRoot.search || routeRoot.hash || !/^[A-Z]{2}$/.test(country) ||
      !/^[A-Z]{3}$/.test(currency) || !Number.isFinite(bandRatio) || bandRatio < 0 || bandRatio > 0.2) {
    throw new Error('Invalid recommendation context');
  }
  let initialized = false;
  let destroyed = false;
  let allowed = false;
  let generation = 0;
  let controller;
  let initialization;
  let privacyTimer;
  let finishPrivacy;
  const context = { currency, country, reason: 'recent-similar-price' };
  const report = (status, extra = {}) => {
    const result = { status, ...context, products: [], ...extra };
    if (!destroyed) { try { onState(result); } catch { /* Consumer isolation. */ } }
    return result;
  };
  const permitted = () => {
    try { return shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; }
    catch { return false; }
  };
  const cancel = () => {
    generation += 1;
    controller?.abort();
    controller = undefined;
  };
  const removeRecord = () => {
    try { getStorage()?.removeItem(RECENT_VIEW_KEY); } catch { /* Blocked storage is not bypassed. */ }
  };
  const notifyPermission = (value) => {
    try { onPermissionChange(value); } catch { /* Search remains independent. */ }
  };
  const refreshPermission = (notifyInitial = false) => {
    if (destroyed) return false;
    const next = permitted();
    const changed = next !== allowed;
    allowed = next;
    if (!next) {
      cancel();
      removeRecord();
      report('disabled');
    }
    if (changed || notifyInitial) notifyPermission(next);
    return next;
  };
  const consentChanged = () => { if (initialized) refreshPermission(); };
  const mayUseHistory = () => {
    if (!initialized || destroyed) return false;
    if (!permitted()) { refreshPermission(); return false; }
    return allowed;
  };
  const validRecord = (record) => record?.version === 1 &&
    typeof record.productId === 'string' && ID.test(record.productId) &&
    typeof record.variantId === 'string' && ID.test(record.variantId) &&
    typeof record.handle === 'string' && HANDLE.test(record.handle) &&
    record.country === country && record.currency === currency &&
    Number.isSafeInteger(record.seenAt) && record.seenAt <= now() &&
    now() - record.seenAt < RECENT_VIEW_TTL;
  const readRecord = () => {
    try {
      const storage = getStorage();
      if (!storage) return null;
      const text = storage.getItem(RECENT_VIEW_KEY);
      if (!text) return null;
      const record = JSON.parse(text);
      if (validRecord(record)) return record;
      removeRecord();
    } catch { removeRecord(); }
    return null;
  };
  const isCurrent = (version) => !destroyed && generation === version && mayUseHistory();
  const endpoint = (path, params) => {
    const url = new URL(`${routeRoot.pathname}${path}`, base);
    for (const [key, value] of Object.entries(params)) url.searchParams.set(key, value);
    return url.href;
  };
  const read = async (url, signal) => {
    const requestController = controller;
    const timeout = setTimer(() => requestController?.abort(), requestTimeout);
    try {
      const response = await fetcher(url, {
        signal, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' },
      });
      if (!response.ok) throw new Error(`Recommendation response ${response.status}`);
      const html = await response.text();
      if (signal.aborted) throw new Error('Recommendation request cancelled');
      if (html.length > 1000000) throw new Error('Recommendation response too large');
      const payload = parsePayload(html);
      if (payload?.version !== 1 || payload.country !== country || payload.currency !== currency ||
          !Array.isArray(payload.products) || payload.products.length > 10) {
        throw new Error('Recommendation market mismatch');
      }
      return payload;
    } finally { clearTimer(timeout); }
  };
  const product = (item) => {
    if (!item || typeof item.id !== 'string' || !ID.test(item.id) ||
        typeof item.variantId !== 'string' || !ID.test(item.variantId) ||
        typeof item.handle !== 'string' || !HANDLE.test(item.handle) ||
        item.available !== true || !Number.isSafeInteger(item.priceMinor) || item.priceMinor <= 0 ||
        typeof item.title !== 'string' || !item.title.trim() || item.title.length > 400 ||
        typeof item.price !== 'string' || !item.price.trim() || item.price.length > 100) return null;
    let url;
    try {
      url = new URL(item.url, base);
      if (url.origin !== base.origin || url.username || url.password ||
          !url.pathname.endsWith(`/products/${item.handle}`)) return null;
    } catch { return null; }
    // Native product handles, localized route and the exact priced variant; no attribution parameters.
    const canonical = endpoint(`products/${item.handle}`, { variant: item.variantId });
    let image = '';
    if (typeof item.image === 'string' && item.image) {
      try {
        const value = new URL(item.image, base);
        if (value.protocol === 'https:' && !value.username && !value.password &&
            (value.hostname === 'cdn.shopify.com' ||
             (value.origin === base.origin && value.pathname.startsWith('/cdn/shop/')))) image = value.href;
      } catch { /* A card can safely omit an invalid image. */ }
    }
    return { id: item.id, variantId: item.variantId, handle: item.handle, title: item.title,
      url: canonical, image, price: item.price, priceMinor: item.priceMinor,
      available: true, currency, country };
  };

  return {
    /** Invokes onPermissionChange once on initialization, including false, then only on changes. */
    init() {
      if (initialization) return initialization;
      initialization = (async () => {
        if (destroyed) return false;
        document?.addEventListener('visitorConsentCollected', consentChanged);
        if (!shopify?.customerPrivacy?.preferencesProcessingAllowed && shopify?.loadFeatures) {
          await new Promise((resolve) => {
            let settled = false;
            finishPrivacy = () => {
              if (settled) return;
              settled = true;
              clearTimer(privacyTimer);
              resolve();
            };
            privacyTimer = setTimer(finishPrivacy, privacyTimeout);
            try { shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], finishPrivacy); }
            catch { finishPrivacy(); }
          });
        }
        if (destroyed) return false;
        initialized = true;
        return refreshPermission(true);
      })();
      return initialization;
    },
    /** Call only for the current product, initially and on its native variant:update event. */
    recordViewed({ productId, handle, variantId }) {
      if (!mayUseHistory()) return false;
      const record = { version: 1, productId: String(productId ?? ''),
        handle, variantId: String(variantId ?? ''), country, currency, seenAt: now() };
      if (!validRecord(record)) return false;
      cancel();
      try {
        const storage = getStorage();
        if (!storage) return false;
        storage.setItem(RECENT_VIEW_KEY, JSON.stringify(record));
        const persisted = storage.getItem(RECENT_VIEW_KEY) === JSON.stringify(record);
        if (!persisted) removeRecord();
        return persisted;
      } catch { removeRecord(); return false; }
    },
    /** Search-page mount calls once, and again only after an actual consent grant. */
    async load() {
      if (!mayUseHistory()) return report('disabled');
      cancel();
      const record = readRecord();
      if (!record) return report('empty');
      const version = generation;
      controller = new AbortController();
      const signal = controller.signal;
      try {
        const sourceData = await read(endpoint(`products/${record.handle}`, {
          variant: record.variantId, section_id: 'ricordo-recent-data',
        }), signal);
        if (!isCurrent(version)) return { status: 'disabled', ...context, products: [] };
        const source = sourceData.mode === 'product' ? product(sourceData.products[0]) : null;
        if (!source || source.id !== record.productId || source.variantId !== record.variantId ||
            source.handle !== record.handle || sourceData.products.length !== 1) return report('empty');
        const related = await read(endpoint('recommendations/products', {
          section_id: 'ricordo-recent-data', product_id: source.id, limit: '10', intent: 'related',
        }), signal);
        if (!isCurrent(version)) return { status: 'disabled', ...context, products: [] };
        if (related.mode !== 'recommendations') throw new Error('Invalid recommendation mode');
        const lowerMinor = Math.ceil(source.priceMinor * (1 - bandRatio));
        const upperMinor = Math.floor(source.priceMinor * (1 + bandRatio));
        const seen = new Set([source.id]);
        const handles = new Set([source.handle]);
        const products = [];
        for (const value of related.products) {
          const candidate = product(value);
          if (!candidate || seen.has(candidate.id) || handles.has(candidate.handle) ||
              candidate.priceMinor < lowerMinor || candidate.priceMinor > upperMinor) continue;
          seen.add(candidate.id); handles.add(candidate.handle); products.push(candidate);
          if (products.length === 3) break;
        }
        return report(products.length ? 'ready' : 'empty', {
          sourceProduct: source, products, priceWindow: { lowerMinor, upperMinor, ratio: bandRatio },
        });
      } catch {
        if (!isCurrent(version)) return { status: 'disabled', ...context, products: [] };
        return report('error');
      }
    },
    clear() { cancel(); removeRecord(); return report(mayUseHistory() ? 'empty' : 'disabled'); },
    destroy() {
      destroyed = true;
      cancel();
      finishPrivacy?.();
      clearTimer(privacyTimer);
      document?.removeEventListener('visitorConsentCollected', consentChanged);
    },
  };
}

return { createRecentRecommendations };
})();
const { renderViewedRecommendations } = (() => {
// Presentation only: consent, history and native Shopify recommendations are
// owned by the caller. This component never stores or requests visitor data.
const COPY = {
  en: { title: 'Inspired by what you viewed', similar: 'Similar prices', basedOn: 'Related finds at a similar price to', available: 'Available', view: 'View product' },
  es: { title: 'Por lo que viste', similar: 'Precios similares', basedOn: 'Productos relacionados de precio similar a', available: 'Disponible', view: 'Ver producto' },
  it: { title: 'Ispirati a ciò che hai visto', similar: 'Prezzi simili', basedOn: 'Prodotti correlati con un prezzo simile a', available: 'Disponibile', view: 'Vedi prodotto' },
  fr: { title: 'Inspirés de vos visites', similar: 'Prix similaires', basedOn: 'Articles associés à un prix similaire à', available: 'Disponible', view: 'Voir le produit' },
  de: { title: 'Passend zu Ihren angesehenen Produkten', similar: 'Ähnliche Preise', basedOn: 'Ähnliche Produkte zu einem vergleichbaren Preis wie', available: 'Verfügbar', view: 'Produkt ansehen' },
  'zh-cn': { title: '根据您浏览的商品', similar: '相近价格', basedOn: '以下相关商品的价格接近', available: '可购买', view: '查看商品' },
  'zh-tw': { title: '根據您瀏覽的商品', similar: '相近價格', basedOn: '以下相關商品的價格接近', available: '可購買', view: '查看商品' },
};

function viewedRecommendationsCopy(locale = 'en') {
  const code = String(locale).toLowerCase();
  const selected = /^zh-(?:hant|tw|hk)/.test(code) ? 'zh-tw' : code === 'zh' || /^zh-(?:hans|cn|sg)/.test(code) ? 'zh-cn' : COPY[code.split('-')[0]] ? code.split('-')[0] : 'en';
  return { ...COPY[selected] };
}

const text = (value) => typeof value === 'string' ? value.trim() : '';
const positiveMinor = (value) => Number.isSafeInteger(value) && value > 0;

function productUrl(value, origin) {
  if (!text(value)) return null;
  try {
    const url = new URL(value, origin);
    return url.origin === origin && !url.username && !url.password &&
      /^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?products\/[^/]+\/?$/i.test(url.pathname) ? url.href : null;
  } catch { return null; }
}

function productImage(value, origin) {
  if (!text(value)) return null;
  try {
    const url = new URL(value, origin);
    return url.protocol === 'https:' && !url.username && !url.password &&
      (url.origin === origin || ['cdn.shopify.com', 'cdn.shopifycdn.net'].includes(url.hostname)) ? url.href : null;
  } catch { return null; }
}

/** Fail closed for incomplete or mismatched current-market recommendations. */
function viewedRecommendationsPresentation({ payload, context, locale, origin }) {
  const copy = viewedRecommendationsCopy(locale);
  const empty = { visible: false, products: [], sourceProduct: null, copy };
  if (!payload || payload.status !== 'ready' || payload.reason !== 'recent-similar-price') return empty;
  const currency = text(context?.currency).toUpperCase();
  const country = text(context?.country).toUpperCase();
  if (!/^[A-Z]{3}$/.test(currency) || !/^[A-Z]{2}$/.test(country) || payload.currency !== currency || payload.country !== country) return empty;
  const source = payload.sourceProduct;
  const sourceUrl = productUrl(source?.url, origin);
  if (!sourceUrl || !text(source?.title) || !text(source?.price) || !positiveMinor(source?.priceMinor) || source.available !== true || source.currency !== currency || source.country !== country) return empty;
  const sourceId = String(source.id || '');
  const sourcePath = new URL(sourceUrl).pathname;
  const productIds = new Set(sourceId ? [sourceId] : []);
  const productPaths = new Set([sourcePath]);
  const products = (Array.isArray(payload.products) ? payload.products : []).flatMap((product) => {
    const url = productUrl(product?.url, origin);
    const title = text(product?.title), price = text(product?.price);
    const id = String(product?.id || '');
    if (!url || !title || !price || product.available !== true || product.currency !== currency || product.country !== country || !positiveMinor(product.priceMinor)) return [];
    // This is an additional presentation guard, never a currency conversion.
    if (product.priceMinor * 100 < source.priceMinor * 80 || product.priceMinor * 100 > source.priceMinor * 120) return [];
    const path = new URL(url).pathname;
    if (productPaths.has(path) || (id && productIds.has(id))) return [];
    productPaths.add(path);
    if (id) productIds.add(id);
    return [{ id, title, url, image: productImage(product.image, origin), price, available: true }];
  }).slice(0, 3);
  if (!products.length) return empty;
  return { visible: true, sourceProduct: { id: sourceId, title: text(source.title), url: sourceUrl, price: text(source.price) }, products, copy };
}

let renderedId = 0;

/** Independent region, not a combobox option or a search-results replacement. */
function renderViewedRecommendations({ container, payload, context, locale, origin }) {
  const doc = container.ownerDocument || document;
  const presentation = viewedRecommendationsPresentation({ payload, context, locale, origin: origin || doc.location?.origin || globalThis.location?.origin });
  container.replaceChildren();
  container.hidden = !presentation.visible;
  if (!presentation.visible) return { productCount: 0, presentation };
  const make = (tag, className, value) => {
    const node = doc.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  };
  const { copy, products, sourceProduct } = presentation;
  const region = make('section', 'rc-viewed-recommendations');
  const heading = make('h2', 'rc-viewed-recommendations__heading', copy.title);
  heading.id = `${container.id || 'rc-viewed-recommendations'}-title-${++renderedId}`;
  region.setAttribute('aria-labelledby', heading.id);
  const subtitle = make('p', 'rc-viewed-recommendations__context');
  subtitle.append(make('span', '', `${copy.basedOn} `));
  const sourceLink = make('a', 'rc-viewed-recommendations__source', sourceProduct.title);
  sourceLink.href = sourceProduct.url;
  subtitle.append(sourceLink, make('span', '', ` · ${sourceProduct.price}`));
  const list = make('ul', 'rc-viewed-recommendations__list');
  for (const product of products) {
    const item = make('li', 'rc-viewed-recommendations__item');
    const link = make('a', 'rc-viewed-recommendations__card');
    link.href = product.url;
    link.setAttribute('aria-label', `${copy.view}: ${product.title}. ${product.price}. ${copy.available}. ${copy.similar}.`);
    if (product.image) {
      const image = make('img', 'rc-viewed-recommendations__image');
      Object.assign(image, { src: product.image, alt: '', width: 96, height: 96, loading: 'lazy', decoding: 'async' });
      link.append(image);
    }
    const content = make('span', 'rc-viewed-recommendations__content');
    content.append(make('span', 'rc-viewed-recommendations__label', copy.similar));
    content.append(make('span', 'rc-viewed-recommendations__title', product.title));
    content.append(make('span', 'rc-viewed-recommendations__price', product.price));
    const action = make('span', 'rc-viewed-recommendations__action', `${copy.view} →`);
    action.setAttribute('aria-hidden', 'true');
    content.append(action);
    link.append(content); item.append(link); list.append(item);
  }
  region.append(heading, subtitle, list); container.append(region);
  return { productCount: products.length, presentation };
}

return { renderViewedRecommendations };
})();
export class RicordoViewedContext extends (globalThis.HTMLElement || class {}) {
  connectedCallback() {
    this.disconnectedCallback();
    const mode = this.dataset.mode;
    if (!['product', 'search'].includes(mode)) return;
    this.container = this.querySelector('[data-rc-viewed-recommendations]');
    if (mode === 'search' && !this.container) return;
    this.currentVariant = this.dataset.variantId || '';
    this.context = { country: this.dataset.country, currency: this.dataset.currency };
    this.events = new AbortController();
    try {
      const root = new URL(this.dataset.root, location.origin);
      if (root.origin !== location.origin || root.search || root.hash || !/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/?)?$/i.test(root.pathname)) throw new Error('Invalid localized root');
      if (!root.pathname.endsWith('/')) root.pathname += '/';
      this.recent = createRecentRecommendations({
        shopify: globalThis.Shopify,
        document,
        getStorage: () => globalThis.sessionStorage,
        fetcher: (...args) => fetch(...args),
        origin: location.origin,
        root: root.pathname,
        ...this.context,
        onState: (payload) => {
          if (this.isConnected && this.container) {
            renderViewedRecommendations({ container: this.container, payload,
              context: this.context, locale: document.documentElement.lang, origin: location.origin });
          }
        },
        onPermissionChange: (allowed) => {
          if (allowed && this.isConnected) this.refreshViewedContext();
        },
      });
      if (mode === 'product') {
        document.addEventListener('variant:update', (event) => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          const variantId = String(event.detail?.resource?.id || '');
          if (!/^\d{1,20}$/.test(variantId)) { this.currentVariant = ''; this.recent?.clear(); return; }
          this.currentVariant = variantId;
          this.refreshViewedContext();
        }, { signal: this.events.signal });
      }
      window.addEventListener('pageshow', (event) => {
        if (event.persisted && this.isConnected) this.refreshViewedContext();
      }, { signal: this.events.signal });
      this.recent.init();
    } catch {
      if (this.container) { this.container.replaceChildren(); this.container.hidden = true; }
    }
  }

  refreshViewedContext() {
    if (this.dataset.mode === 'product') {
      this.recent?.recordViewed({ productId: this.dataset.productId,
        handle: this.dataset.productHandle, variantId: this.currentVariant });
    } else {
      this.recent?.load();
    }
  }

  disconnectedCallback() {
    this.events?.abort();
    this.recent?.destroy();
    this.recent = null;
  }
}

if (globalThis.customElements && !customElements.get('ricordo-viewed-context')) {
  customElements.define('ricordo-viewed-context', RicordoViewedContext);
}
